// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.button {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 16px;
    border-radius: 6px;
    font-weight: 500;
    transition: all 0.2s;
}

.button.default {
    background-color: #2fd8a0;
    color: white;
    border-color: #27c895;
    box-shadow: 0 2px 4px rgba(47, 216, 160, 0.25);
    transition: all 0.2s ease;
}

.button.default:hover {
    background-color: #27c895;
    transform: translateY(-2px);
    box-shadow: 0 4px 8px rgba(47, 216, 160, 0.3);
}

.input {
    width: 100%;
    padding: 8px 12px;
    border: 1px solid #ccc;
    border-radius: 4px;
}

.tabs-container {
    display: flex;
    justify-content: center;
}

.tabs {
    width: 65%;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.tabs-list {
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #0596a3;
    padding: 5px;
    gap: 4px;
}

.tab-trigger {
    padding: 10px 16px;
    cursor: pointer;
    border: none;
    background: none;
    transition: color 0.2s ease;
    font-size: 1rem;
}

.tab-trigger.active {
    font-weight: bold;
    border-bottom: 3px solid white;
    color: white;
}

.tab-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    padding: 16px;
    background: #f9f7f7;
    min-height: 29.4vh;
    gap: 2rem;
}

.bio {
    justify-content: space-evenly;
}

.tab-content span {
    color: #06a5b3;
}

.activity-container {
    width: 80%;
}

.faculty-profile {
    min-height: 70vh;
    background-color: #fff;
    margin-bottom: 100px;
}

.profile-header {
    width: 100%;
    padding: 1.5rem 0;
    margin-bottom: 2rem;
    position: relative;
}

.header-content {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    width: 100%;
}

.faculty-info {
    text-align: center;
}

.faculty-info h2 {
    margin: 0;
    font-size: 1.5rem;
    color: #2d3748;
    display: inline-block;
}

.faculty-info h2 span {
    color: #05828e;
}

.back-button-home {
    position: absolute;
    left: 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 0.5rem;
    background-color: #c1ddf9;
    color: #0ea77c;
    width: 10%;
    text-decoration: none;
    padding: 0.5rem 1rem;
    border-radius: 8px;
    transition: all 0.2s ease;
}

.back-button-home:hover {
    background-color: #9ecfff;
    color: #4a5568;
}

.back-button-home span {
    font-size: 0.95rem;
}

@media (max-width: 768px) {
    .faculty-info h2 {
        font-size: 1.3rem;
        padding: 0 3rem;
    }

    .back-button {
        position: static;
        margin-right: auto;
    }

    .header-content {
        justify-content: space-between;
    }
}

.activity-header {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 1.5rem;
}

.activity-header h3 {
    margin: 0;
    order: 2;
}

.search-container-profile {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    gap: 10px;
}

.input-wrapper-profile {
    position: relative;
    width: 100%;
}

.search-icon-profile {
    position: absolute;
    left: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    width: 1rem;
    height: 1rem;
    color: #a0aec0;
}

.search-input-profile {
    width: 100%;
    padding: 0.5rem 0.75rem 0.5rem 2.5rem;
    font-size: 0.875rem;
    border: 1px solid #e2e8f0;
    border-radius: 0.375rem;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
    background-color: white;
    font-family: Vazir, sans-serif;
}

.clear-search {
    position: absolute;
    right: 0.75rem;
    top: 50%;
    transform: translateY(-50%);
    background: none;
    border: none;
    color: #a0aec0;
    cursor: pointer;
    padding: 0.25rem;
}

.clear-search:hover {
    color: #e53e3e;
}

@media (max-width: 768px) {
    .activity-header {
        flex-direction: column;
        align-items: flex-start;
    }

    .activity-search {
        max-width: 100%;
    }
}

.faculty-image {
    width: 100%;
    border-radius: 8px;
}

.faculty-contact {
    display: flex;
    align-items: center;
    gap: 8px;
}

.icon {
    width: 16px;
    height: 16px;
}

.faculty-tabs {
    padding: 16px;
    border-radius: 8px;
    background: #fff;
}

.activity-types {
    width: 100%;
    margin: 70px 0 0 0;
    position: sticky;
    top: 20px;
    align-self: flex-start;
    height: fit-content;
}

.activity-buttons {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-bottom: 0;
    grid-template-columns: unset;
}

.activity-results {
    width: 100%;
    /* flex-grow: 1; */
}

.activity-results h3 {
    color: #2d3748;
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e2e8f0;
    text-align: center;
}

.activity-results .activities-grid {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1.2rem;
}

.activity-results .activity-card {
    min-width: 150px;
    width: 80%;
    padding: 1.2rem;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
    transition: all 0.2s ease;
    border-top: 3px solid #0563a3;
}

.activity-results .activity-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}

.activity-results .activity-title {
    color: #2d3748;
    font-weight: 600;
    margin-bottom: 0.5rem;
    font-size: 1.05rem;
}

.activity-results .activity-description {
    color: #4a5568;
    font-size: 0.9rem;
    line-height: 1.5;
}

.activity-results .status-message {
    text-align: center;
    padding: 1.5rem;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.activity-container-profile {
    display: flex;
    justify-content: center;
    position: relative;
    gap: 1.5rem;
}

.sidebar-toggle {
    position: fixed;
    top: 20px;
    right: 20px;
    z-index: 100;
    background-color: #0596a3;
    color: white;
    border: none;
    border-radius: 50px;
    padding: 12px 20px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    cursor: pointer;
    gap: 8px;
    transition: all 0.3s ease;
    display: flex;
    justify-content: center;
    align-items: center;
}

.sidebar-toggle:hover {
    background-color: #068893;
    transform: translateY(-2px);
}

.sidebar-toggle>span {
    color: white;
    font-size: 0.875rem;
    font-weight: 500;
    font-family: 'Vazir', sans-serif;
}

.activity-sidebar {
    position: fixed;
    top: 0;
    right: -350px;
    bottom: 0;
    z-index: 90;
    background: white;
    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
    padding: 1.5rem;
    overflow-y: auto;
}

.activity-sidebar.open {
    right: 0;
}

.activity-sidebar h3 {
    color: #2d3748;
    font-size: 1.3rem;
    margin-bottom: 1.5rem;
    padding-bottom: 0.75rem;
    border-bottom: 1px solid #e2e8f0;
}

.activity-buttons {
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
}

.activity-button-item {
    padding: 0.8rem 0.5rem;
    border-radius: 8px;
    font-size: 0.95rem;
    transition: all 0.2s ease;
    border: 1px solid #e2e8f0;
    background-color: #f8fafc;
    color: #2d3748;
    text-align: right;
    width: 100%;
    min-height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 1rem;
    cursor: pointer;
}

.activity-button-item:hover {
    background-color: #f1f5f9;
    transform: translateX(5px);
}

.activity-button-item.active {
    background-color: #e6f7f2;
    color: #0ea77c;
}

.activity-button-icon {
    margin-right: 12px;
    font-size: 1.1rem;
    width: 24px;
    display: flex;
    justify-content: center;
}

.activity-button-title {
    flex-grow: 1;
}

.activity-button-indicator {
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 0;
    transition: all 0.2s ease;
}

.activity-main-content {
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}

.empty-state {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;
    color: #718096;
    grid-column: 1 / -1;
}

@media (max-width: 768px) {
    .activity-container-profile {
        flex-direction: column;
    }

    .sidebar-toggle {
        display: flex;
    }

    .activity-sidebar {
        position: fixed;
        top: 0;
        left: -280px;
        bottom: 0;
        z-index: 90;
        background: white;
        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);
        padding: 1.5rem;
        overflow-y: auto;
    }

    .activity-sidebar.open {
        left: 0;
    }

    .activity-main-content {
        width: 100%;
    }
}

@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(10px);
    }

    to {
        opacity: 1;
        transform: translateY(0);
    }
}

.activity-card {
    animation: fadeIn 0.3s ease forwards;
}

.activity-card:nth-child(1) {
    animation-delay: 0.1s;
}

.activity-card:nth-child(2) {
    animation-delay: 0.2s;
}

.activity-card:nth-child(3) {
    animation-delay: 0.3s;
}

.activity-results .loading-message {
    color: #0ea77c;
}

.activity-results .error-message {
    color: #e53e3e;
}

.activity-fields {
    margin-top: 1rem;
    border-top: 1px solid #e2e8f0;
    padding-top: 0.8rem;
}

.activity-field {
    display: flex;
    justify-content: space-between;
    margin-bottom: 0.5rem;
    font-size: 0.9rem;
}

.field-label {
    font-weight: 500;
}

.field-value {
    color: #2d3748 !important;
    text-align: left;
    max-width: 60%;
}

.field-value a {
    color: #0ea77c;
    text-decoration: none;
}

.field-value a:hover {
    text-decoration: underline;
}

@media (max-width: 768px) {
    .tab-content {
        flex-direction: column;
    }

    .activity-types,
    .activity-results {
        width: 100%;
    }

    .activity-types {
        position: static;
    }

    .activity-buttons {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .activity-button {
        width: auto;
        flex-grow: 1;
    }
}

@media (max-width: 768px) {
    .profile-header {
        padding: 1rem 0;
        margin-bottom: 1rem;
        display: flex;
        flex-direction: column;
    }

    .header-content {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        position: relative;
        padding-top: 3rem;
    }

    .faculty-info {
        order: 1;
        text-align: center;
        margin-top: 1rem;
    }

    .back-button-home {
        position: absolute;
        left: 1rem;
        top: 0;
        margin: 0;
        order: 2;
        width: auto;
    }

    .sidebar-toggle {
        position: absolute;
        right: 1rem;
        top: 1rem;
        left: auto;
        order: 3;
        margin: 0;
    }

    .tabs {
        width: 90%;
    }

    .tab-content {
        flex-direction: column;
        gap: 1rem;
        padding: 1rem;
    }

    .activity-container {
        width: 100%;
    }

    .activity-results .activity-card {
        width: 100%;
    }

    .activity-field {
        flex-direction: column;
        gap: 0.25rem;
    }

    .field-value {
        max-width: 100%;
        text-align: right;
    }

    .activity-sidebar {
        width: 80%;
        padding: 1rem;
    }

    .activity-buttons {
        gap: 0.5rem;
    }

    .activity-button-item {
        padding: 0.6rem;
        font-size: 0.85rem;
    }

    .activity-button-icon {
        margin-right: 8px;
        font-size: 1rem;
    }

    .search-container-profile {
        width: 100%;
    }

    .input-wrapper {
        width: 100%;
    }
}

@media (max-width: 480px) {
    .faculty-info h2 {
        font-size: 1.1rem;
    }

    .back-button-home {
        padding: 0.4rem 0.8rem;
        font-size: 0.8rem;
    }

    .sidebar-toggle {
        padding: 0.5rem 1rem;
        font-size: 0.8rem;
    }

    .tab-trigger {
        padding: 8px 12px;
        font-size: 0.9rem;
    }

    .activity-results h3 {
        font-size: 1.1rem;
    }

    .activity-title {
        font-size: 1rem;
    }

    .activity-description {
        font-size: 0.85rem;
    }
}

.activity-sidebar {
    width: 320px;
    padding: 1rem;
}

.activity-buttons {
    gap: 0.4rem;
}

.activity-button-item {
    padding: 0.6rem 0.5rem;
    font-size: 0.9rem;
    min-height: auto;
}

.activity-button-icon {
    margin-right: 8px;
    font-size: 1rem;
    width: 20px;
}

.activity-sidebar h3 {
    font-size: 1.1rem;
    margin-bottom: 1rem;
    padding-bottom: 0.5rem;
}

@media (max-width: 768px) {
    .activity-sidebar {
        width: 70%;
        padding: 0.8rem;
    }

    .activity-button-item {
        padding: 0.5rem;
    }
}`, "",{"version":3,"sources":["webpack://./src/pages/ProfessorProfile/ProfessorProfile.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;AACxB;;AAEA;IACI,yBAAyB;IACzB,YAAY;IACZ,qBAAqB;IACrB,8CAA8C;IAC9C,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,UAAU;IACV,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,YAAY;IACZ,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,gBAAgB;IAChB,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,iBAAiB;IACjB,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;IACX,yBAAyB;IACzB,cAAc;IACd,UAAU;IACV,qBAAqB;IACrB,oBAAoB;IACpB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,gBAAgB;QAChB,kBAAkB;IACtB;;IAEA;QACI,8BAA8B;IAClC;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,qBAAqB;AACzB;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,SAAS;AACb;;AAEA;IACI,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,QAAQ;IACR,2BAA2B;IAC3B,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,qCAAqC;IACrC,mBAAmB;IACnB,yBAAyB;IACzB,uBAAuB;IACvB,yCAAyC;IACzC,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,YAAY;IACZ,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI;QACI,sBAAsB;QACtB,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,gBAAgB;IAChB,SAAS;IACT,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;IAChC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;IACzC,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,wCAAwC;AAC5C;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,uBAAuB;IACvB,kBAAkB;IAClB,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,SAAS;IACT,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,kBAAkB;IAClB,0CAA0C;IAC1C,eAAe;IACf,QAAQ;IACR,yBAAyB;IACzB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;AAC/B;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,MAAM;IACN,aAAa;IACb,SAAS;IACT,WAAW;IACX,iBAAiB;IACjB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,QAAQ;AACZ;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,uBAAuB;IACvB,gCAAgC;AACpC;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,kBAAkB;IAClB,yBAAyB;IACzB,yBAAyB;IACzB,yBAAyB;IACzB,cAAc;IACd,iBAAiB;IACjB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;AAC9B;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,iBAAiB;IACjB,WAAW;IACX,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,OAAO;IACP,MAAM;IACN,SAAS;IACT,QAAQ;IACR,yBAAyB;AAC7B;;AAEA;IACI,WAAW;IACX,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;IACb,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;QACf,MAAM;QACN,YAAY;QACZ,SAAS;QACT,WAAW;QACX,iBAAiB;QACjB,yCAAyC;QACzC,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,OAAO;IACX;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;;IAEA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI;QACI,sBAAsB;IAC1B;;IAEA;;QAEI,WAAW;IACf;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;AACJ;;AAEA;IACI;QACI,eAAe;QACf,mBAAmB;QACnB,aAAa;QACb,sBAAsB;IAC1B;;IAEA;QACI,aAAa;QACb,sBAAsB;QACtB,SAAS;QACT,kBAAkB;QAClB,iBAAiB;IACrB;;IAEA;QACI,QAAQ;QACR,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,UAAU;QACV,MAAM;QACN,SAAS;QACT,QAAQ;QACR,WAAW;IACf;;IAEA;QACI,kBAAkB;QAClB,WAAW;QACX,SAAS;QACT,UAAU;QACV,QAAQ;QACR,SAAS;IACb;;IAEA;QACI,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,iBAAiB;QACjB,eAAe;IACnB;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA;IACI;QACI,iBAAiB;IACrB;;IAEA;QACI,sBAAsB;QACtB,iBAAiB;IACrB;;IAEA;QACI,oBAAoB;QACpB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;QACjB,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI,YAAY;IACZ,aAAa;AACjB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI;QACI,UAAU;QACV,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ","sourcesContent":[".button {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 10px 16px;\n    border-radius: 6px;\n    font-weight: 500;\n    transition: all 0.2s;\n}\n\n.button.default {\n    background-color: #2fd8a0;\n    color: white;\n    border-color: #27c895;\n    box-shadow: 0 2px 4px rgba(47, 216, 160, 0.25);\n    transition: all 0.2s ease;\n}\n\n.button.default:hover {\n    background-color: #27c895;\n    transform: translateY(-2px);\n    box-shadow: 0 4px 8px rgba(47, 216, 160, 0.3);\n}\n\n.input {\n    width: 100%;\n    padding: 8px 12px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n}\n\n.tabs-container {\n    display: flex;\n    justify-content: center;\n}\n\n.tabs {\n    width: 65%;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n}\n\n.tabs-list {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #0596a3;\n    padding: 5px;\n    gap: 4px;\n}\n\n.tab-trigger {\n    padding: 10px 16px;\n    cursor: pointer;\n    border: none;\n    background: none;\n    transition: color 0.2s ease;\n    font-size: 1rem;\n}\n\n.tab-trigger.active {\n    font-weight: bold;\n    border-bottom: 3px solid white;\n    color: white;\n}\n\n.tab-content {\n    display: flex;\n    flex-direction: row;\n    justify-content: center;\n    padding: 16px;\n    background: #f9f7f7;\n    min-height: 29.4vh;\n    gap: 2rem;\n}\n\n.bio {\n    justify-content: space-evenly;\n}\n\n.tab-content span {\n    color: #06a5b3;\n}\n\n.activity-container {\n    width: 80%;\n}\n\n.faculty-profile {\n    min-height: 70vh;\n    background-color: #fff;\n    margin-bottom: 100px;\n}\n\n.profile-header {\n    width: 100%;\n    padding: 1.5rem 0;\n    margin-bottom: 2rem;\n    position: relative;\n}\n\n.header-content {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: relative;\n    width: 100%;\n}\n\n.faculty-info {\n    text-align: center;\n}\n\n.faculty-info h2 {\n    margin: 0;\n    font-size: 1.5rem;\n    color: #2d3748;\n    display: inline-block;\n}\n\n.faculty-info h2 span {\n    color: #05828e;\n}\n\n.back-button-home {\n    position: absolute;\n    left: 50px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 0.5rem;\n    background-color: #c1ddf9;\n    color: #0ea77c;\n    width: 10%;\n    text-decoration: none;\n    padding: 0.5rem 1rem;\n    border-radius: 8px;\n    transition: all 0.2s ease;\n}\n\n.back-button-home:hover {\n    background-color: #9ecfff;\n    color: #4a5568;\n}\n\n.back-button-home span {\n    font-size: 0.95rem;\n}\n\n@media (max-width: 768px) {\n    .faculty-info h2 {\n        font-size: 1.3rem;\n        padding: 0 3rem;\n    }\n\n    .back-button {\n        position: static;\n        margin-right: auto;\n    }\n\n    .header-content {\n        justify-content: space-between;\n    }\n}\n\n.activity-header {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 1.5rem;\n}\n\n.activity-header h3 {\n    margin: 0;\n    order: 2;\n}\n\n.search-container-profile {\n    display: flex;\n    justify-content: flex-end;\n    flex-wrap: wrap;\n    gap: 10px;\n}\n\n.input-wrapper-profile {\n    position: relative;\n    width: 100%;\n}\n\n.search-icon-profile {\n    position: absolute;\n    left: 0.75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    width: 1rem;\n    height: 1rem;\n    color: #a0aec0;\n}\n\n.search-input-profile {\n    width: 100%;\n    padding: 0.5rem 0.75rem 0.5rem 2.5rem;\n    font-size: 0.875rem;\n    border: 1px solid #e2e8f0;\n    border-radius: 0.375rem;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n    background-color: white;\n    font-family: Vazir, sans-serif;\n}\n\n.clear-search {\n    position: absolute;\n    right: 0.75rem;\n    top: 50%;\n    transform: translateY(-50%);\n    background: none;\n    border: none;\n    color: #a0aec0;\n    cursor: pointer;\n    padding: 0.25rem;\n}\n\n.clear-search:hover {\n    color: #e53e3e;\n}\n\n@media (max-width: 768px) {\n    .activity-header {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .activity-search {\n        max-width: 100%;\n    }\n}\n\n.faculty-image {\n    width: 100%;\n    border-radius: 8px;\n}\n\n.faculty-contact {\n    display: flex;\n    align-items: center;\n    gap: 8px;\n}\n\n.icon {\n    width: 16px;\n    height: 16px;\n}\n\n.faculty-tabs {\n    padding: 16px;\n    border-radius: 8px;\n    background: #fff;\n}\n\n.activity-types {\n    width: 100%;\n    margin: 70px 0 0 0;\n    position: sticky;\n    top: 20px;\n    align-self: flex-start;\n    height: fit-content;\n}\n\n.activity-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    margin-bottom: 0;\n    grid-template-columns: unset;\n}\n\n.activity-results {\n    width: 100%;\n    /* flex-grow: 1; */\n}\n\n.activity-results h3 {\n    color: #2d3748;\n    font-size: 1.3rem;\n    margin-bottom: 1.5rem;\n    padding-bottom: 0.75rem;\n    border-bottom: 1px solid #e2e8f0;\n    text-align: center;\n}\n\n.activity-results .activities-grid {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    gap: 1.2rem;\n}\n\n.activity-results .activity-card {\n    min-width: 150px;\n    width: 80%;\n    padding: 1.2rem;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n    transition: all 0.2s ease;\n    border-top: 3px solid #0563a3;\n}\n\n.activity-results .activity-card:hover {\n    transform: translateY(-3px);\n    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n}\n\n.activity-results .activity-title {\n    color: #2d3748;\n    font-weight: 600;\n    margin-bottom: 0.5rem;\n    font-size: 1.05rem;\n}\n\n.activity-results .activity-description {\n    color: #4a5568;\n    font-size: 0.9rem;\n    line-height: 1.5;\n}\n\n.activity-results .status-message {\n    text-align: center;\n    padding: 1.5rem;\n    background-color: white;\n    border-radius: 8px;\n    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.activity-container-profile {\n    display: flex;\n    justify-content: center;\n    position: relative;\n    gap: 1.5rem;\n}\n\n.sidebar-toggle {\n    position: fixed;\n    top: 20px;\n    right: 20px;\n    z-index: 100;\n    background-color: #0596a3;\n    color: white;\n    border: none;\n    border-radius: 50px;\n    padding: 12px 20px;\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);\n    cursor: pointer;\n    gap: 8px;\n    transition: all 0.3s ease;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.sidebar-toggle:hover {\n    background-color: #068893;\n    transform: translateY(-2px);\n}\n\n.sidebar-toggle>span {\n    color: white;\n    font-size: 0.875rem;\n    font-weight: 500;\n    font-family: 'Vazir', sans-serif;\n}\n\n.activity-sidebar {\n    position: fixed;\n    top: 0;\n    right: -350px;\n    bottom: 0;\n    z-index: 90;\n    background: white;\n    box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n    padding: 1.5rem;\n    overflow-y: auto;\n}\n\n.activity-sidebar.open {\n    right: 0;\n}\n\n.activity-sidebar h3 {\n    color: #2d3748;\n    font-size: 1.3rem;\n    margin-bottom: 1.5rem;\n    padding-bottom: 0.75rem;\n    border-bottom: 1px solid #e2e8f0;\n}\n\n.activity-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 0.5rem;\n}\n\n.activity-button-item {\n    padding: 0.8rem 0.5rem;\n    border-radius: 8px;\n    font-size: 0.95rem;\n    transition: all 0.2s ease;\n    border: 1px solid #e2e8f0;\n    background-color: #f8fafc;\n    color: #2d3748;\n    text-align: right;\n    width: 100%;\n    min-height: auto;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    gap: 1rem;\n    cursor: pointer;\n}\n\n.activity-button-item:hover {\n    background-color: #f1f5f9;\n    transform: translateX(5px);\n}\n\n.activity-button-item.active {\n    background-color: #e6f7f2;\n    color: #0ea77c;\n}\n\n.activity-button-icon {\n    margin-right: 12px;\n    font-size: 1.1rem;\n    width: 24px;\n    display: flex;\n    justify-content: center;\n}\n\n.activity-button-title {\n    flex-grow: 1;\n}\n\n.activity-button-indicator {\n    position: absolute;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    width: 0;\n    transition: all 0.2s ease;\n}\n\n.activity-main-content {\n    width: 100%;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.empty-state {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n    color: #718096;\n    grid-column: 1 / -1;\n}\n\n@media (max-width: 768px) {\n    .activity-container-profile {\n        flex-direction: column;\n    }\n\n    .sidebar-toggle {\n        display: flex;\n    }\n\n    .activity-sidebar {\n        position: fixed;\n        top: 0;\n        left: -280px;\n        bottom: 0;\n        z-index: 90;\n        background: white;\n        box-shadow: 2px 0 10px rgba(0, 0, 0, 0.1);\n        padding: 1.5rem;\n        overflow-y: auto;\n    }\n\n    .activity-sidebar.open {\n        left: 0;\n    }\n\n    .activity-main-content {\n        width: 100%;\n    }\n}\n\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: translateY(10px);\n    }\n\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n.activity-card {\n    animation: fadeIn 0.3s ease forwards;\n}\n\n.activity-card:nth-child(1) {\n    animation-delay: 0.1s;\n}\n\n.activity-card:nth-child(2) {\n    animation-delay: 0.2s;\n}\n\n.activity-card:nth-child(3) {\n    animation-delay: 0.3s;\n}\n\n.activity-results .loading-message {\n    color: #0ea77c;\n}\n\n.activity-results .error-message {\n    color: #e53e3e;\n}\n\n.activity-fields {\n    margin-top: 1rem;\n    border-top: 1px solid #e2e8f0;\n    padding-top: 0.8rem;\n}\n\n.activity-field {\n    display: flex;\n    justify-content: space-between;\n    margin-bottom: 0.5rem;\n    font-size: 0.9rem;\n}\n\n.field-label {\n    font-weight: 500;\n}\n\n.field-value {\n    color: #2d3748 !important;\n    text-align: left;\n    max-width: 60%;\n}\n\n.field-value a {\n    color: #0ea77c;\n    text-decoration: none;\n}\n\n.field-value a:hover {\n    text-decoration: underline;\n}\n\n@media (max-width: 768px) {\n    .tab-content {\n        flex-direction: column;\n    }\n\n    .activity-types,\n    .activity-results {\n        width: 100%;\n    }\n\n    .activity-types {\n        position: static;\n    }\n\n    .activity-buttons {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n\n    .activity-button {\n        width: auto;\n        flex-grow: 1;\n    }\n}\n\n@media (max-width: 768px) {\n    .profile-header {\n        padding: 1rem 0;\n        margin-bottom: 1rem;\n        display: flex;\n        flex-direction: column;\n    }\n\n    .header-content {\n        display: flex;\n        flex-direction: column;\n        gap: 1rem;\n        position: relative;\n        padding-top: 3rem;\n    }\n\n    .faculty-info {\n        order: 1;\n        text-align: center;\n        margin-top: 1rem;\n    }\n\n    .back-button-home {\n        position: absolute;\n        left: 1rem;\n        top: 0;\n        margin: 0;\n        order: 2;\n        width: auto;\n    }\n\n    .sidebar-toggle {\n        position: absolute;\n        right: 1rem;\n        top: 1rem;\n        left: auto;\n        order: 3;\n        margin: 0;\n    }\n\n    .tabs {\n        width: 90%;\n    }\n\n    .tab-content {\n        flex-direction: column;\n        gap: 1rem;\n        padding: 1rem;\n    }\n\n    .activity-container {\n        width: 100%;\n    }\n\n    .activity-results .activity-card {\n        width: 100%;\n    }\n\n    .activity-field {\n        flex-direction: column;\n        gap: 0.25rem;\n    }\n\n    .field-value {\n        max-width: 100%;\n        text-align: right;\n    }\n\n    .activity-sidebar {\n        width: 80%;\n        padding: 1rem;\n    }\n\n    .activity-buttons {\n        gap: 0.5rem;\n    }\n\n    .activity-button-item {\n        padding: 0.6rem;\n        font-size: 0.85rem;\n    }\n\n    .activity-button-icon {\n        margin-right: 8px;\n        font-size: 1rem;\n    }\n\n    .search-container-profile {\n        width: 100%;\n    }\n\n    .input-wrapper {\n        width: 100%;\n    }\n}\n\n@media (max-width: 480px) {\n    .faculty-info h2 {\n        font-size: 1.1rem;\n    }\n\n    .back-button-home {\n        padding: 0.4rem 0.8rem;\n        font-size: 0.8rem;\n    }\n\n    .sidebar-toggle {\n        padding: 0.5rem 1rem;\n        font-size: 0.8rem;\n    }\n\n    .tab-trigger {\n        padding: 8px 12px;\n        font-size: 0.9rem;\n    }\n\n    .activity-results h3 {\n        font-size: 1.1rem;\n    }\n\n    .activity-title {\n        font-size: 1rem;\n    }\n\n    .activity-description {\n        font-size: 0.85rem;\n    }\n}\n\n.activity-sidebar {\n    width: 320px;\n    padding: 1rem;\n}\n\n.activity-buttons {\n    gap: 0.4rem;\n}\n\n.activity-button-item {\n    padding: 0.6rem 0.5rem;\n    font-size: 0.9rem;\n    min-height: auto;\n}\n\n.activity-button-icon {\n    margin-right: 8px;\n    font-size: 1rem;\n    width: 20px;\n}\n\n.activity-sidebar h3 {\n    font-size: 1.1rem;\n    margin-bottom: 1rem;\n    padding-bottom: 0.5rem;\n}\n\n@media (max-width: 768px) {\n    .activity-sidebar {\n        width: 70%;\n        padding: 0.8rem;\n    }\n\n    .activity-button-item {\n        padding: 0.5rem;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
